import script from "./CuButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CuButton.vue?vue&type=script&setup=true&lang=js"

import "./CuButton.vue?vue&type=style&index=0&id=1a89b305&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a89b305"]])

export default __exports__